// Usuwa element pozostawiając jego dzieci (el: selector, np. '.class')
const unwrap = (tab, elem) => {
    const element = tab.querySelector(elem);
    const parent = element.parentNode;

    while (element.firstChild) parent.insertBefore(element.firstChild, element);

    parent.removeChild(element);
};

const isVisible = (elem) => {

    return !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

};


//!!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)

const debounce = (func, wait, immediate) => {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

const findSiblings = elem => {
    var siblings = [];
    var sibling = elem.parentNode.firstChild;

    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== elem) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
    }

    return siblings;
};

const getQueryVariable = variable => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) { return pair[1]; }
    }
    return false;
};

// Serializowanie formularza
const serialize = function (form) {
    var serialized = [];

    for (var i = 0; i < form.elements.length; i++) {
        var field = form.elements[i];

        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

        if (field.type === 'select-multiple') {
            for (var n = 0; n < field.options.length; n++) {
                if (!field.options[n].selected) continue;
                serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
            }
        }

        else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
        }
    }

    return serialized.join('&');
};

const slideUp = (target, duration = 500) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
};

const slideDown = (target, duration = 500) => {
    target.style.removeProperty('display');

    let display = window.getComputedStyle(target).display;

    if (display === 'none') {
        display = 'block';
    }

    target.style.display = display;

    let height = target.offsetHeight;

    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
};

const slideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
    } else {
        return slideUp(target, duration);
    }
};

const offset = el => {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
};

const getScript = (source, callback) => {
    var script = document.createElement('script');
    var prior = document.querySelectorAll('script')[0];
    script.async = 1;

    script.onload = script.onreadystatechange = (_, isAbort) => {
        if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
            script.onload = script.onreadystatechange = null;
            script = undefined;
            if (!isAbort) if (callback) callback();
        }
    };

    script.src = source;
    prior.parentNode.insertBefore(script, prior);
};


const showLoader = () => {
    const LOADER_ID = 'loading';
    if (document.getElementById(LOADER_ID)) return;

    const loader = document.createElement('div');
    loader.id = LOADER_ID;
    loader.innerHTML = `<div></div>`;
    document.body.appendChild(loader);

    requestAnimationFrame(() => {
        requestAnimationFrame(() => loader.classList.add('show'));
    });
}

const hideLoader = () => {
    const loading = document.querySelector('#loading');
    if (!loading) return;

    setTimeout(() => {
        loading.classList.remove('show');

        setTimeout(() => {
            if (loading.classList.contains('show')) return;
            loading?.remove();
        }, 150);
    }, 200);
}


const conditionalContentSet = (scope, selector, value) => {

    const items = scope.querySelectorAll(selector);

    if (!items || items.length === 0) {
      return;
    }
    items.forEach(item => {
        item.innerHTML = value || '';
    });

}

const conditionalImgSet = (scope, selector, value) => {

    const items = scope.querySelectorAll(selector);

    if (!items || items.length === 0) {
        return;
    }

    items.forEach(item => {
        item.src = value || '';
    });

}

const whenIdle = (callback, timeout = 2000) => {
    if ('requestIdleCallback' in window) {
        return requestIdleCallback(callback, { timeout });
    }
    return setTimeout(callback, 1);
};


export {
    unwrap,
    isVisible,
    debounce,
    findSiblings,
    getQueryVariable,
    serialize,
    slideUp,
    slideDown,
    slideToggle,
    offset,
    getScript,
    showLoader,
    hideLoader,
    conditionalContentSet,
    conditionalImgSet,
    whenIdle
};